import { GetUsersParams, UsersSortByParam } from "@bvhi/backend-api/apis";

export const defaultUsersFilter: GetUsersParams = {
  page: 0,
  size: 25,
  sort: [UsersSortByParam.LAST_NAME_ASC],
  status: ["ACTIVE", "INACTIVE"],
};
